var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrailingIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0008 10.5001V6.50008M10.0008 6.50008H6.00078M10.0008 6.50008L6.00078 10.5M14.6673 8.50004C14.6673 12.1819 11.6826 15.1667 8.00065 15.1667C4.31875 15.1667 1.33398 12.1819 1.33398 8.50004C1.33398 4.81814 4.31875 1.83337 8.00065 1.83337C11.6826 1.83337 14.6673 4.81814 14.6673 8.50004Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrailingIcon6);
export default __webpack_public_path__ + "static/media/Trailing Icon (6).9ed96c3cd7155abd4989124240e749b4.svg";
export { ForwardRef as ReactComponent };